import { reactive } from 'vue';

export const toastEvent = reactive({
  messages: [] as { id: number; type: 'success' | 'error'; text: string; timeout: number }[],
});

let toastId = 0;

export const showToast = (type: 'success' | 'error', message: string, timeout?: number) => {
  const newToast = { 
    id: ++toastId, 
    type, 
    text: message, 
    timeout: type === 'error' ? -1 : timeout ?? 3000 // Error messages stay until manually closed
  };

  toastEvent.messages.push(newToast);

  console.groupCollapsed(`🎉 [Toast Created] ID: ${newToast.id}`);
  console.log(`🆕 Toast #${newToast.id} added.`);
  console.log(`ℹ️ Type: ${newToast.type}`);
  console.log(`🕒 Timeout: ${newToast.timeout === -1 ? "No Timeout (Persistent Error)" : newToast.timeout + "ms"}`);
  console.groupEnd();
};

export const removeToast = (id: number) => {
  const index = toastEvent.messages.findIndex((msg) => msg.id === id);
  if (index !== -1) {
    console.groupCollapsed(`🗑️ [Toast Removed] ID: ${id}`);
    console.log(`🔥 Toast #${id} is now removed.`);
    console.groupEnd();

    toastEvent.messages.splice(index, 1);
  }
};